import { useQuery } from '@tanstack/react-query'
import { CommentResponse, CommentsHttpClient } from '@omnea-app/comments/commentsHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { ThreadInfo } from './useRequestComments'

export const requestCommentsQueryKey = 'requestComments'

export type RequestCommentsResponse = CommentResponse<'/request-comments/{requestId}', 'get'>
export type RequestCommentsData = NonNullable<RequestCommentsResponse['data']>

interface UseGetRequestCommentOptions<TData = RequestCommentsData> {
  skip?: boolean
  refetchInterval?: number
  select?: (data: RequestCommentsData) => TData
}

export function useGetRequestComment<TData = RequestCommentsData>(
  { requestId, requestFormId, questionId, taskId, rfxId }: ThreadInfo,
  options?: UseGetRequestCommentOptions<TData>
) {
  const { getToken } = useAuthenticatedUser()

  return useQuery<RequestCommentsData, Error, TData>({
    queryKey: [requestCommentsQueryKey, requestId, requestFormId, questionId, taskId, rfxId],
    refetchInterval: options?.refetchInterval,
    enabled: !options?.skip,
    select: options?.select,
    queryFn: async () => {
      const apiClient = new CommentsHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.GET('/request-comments/{requestId}', {
        params: {
          path: {
            requestId,
          },
          query: {
            requestFormId,
            questionId,
            taskId,
            rfxId,
          },
        },
      })
      throwIfApiError(error)
      return data
    },
  })
}
